/**
 * debug logging in case of errors and warnings
 */
export const log = (msg: string) => {
    console.log(`DataGrid Library: ${msg}`);
};